import { createMuiTheme, createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const styleTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#FF505F',
    },
    secondary: {
      main: '#007DFF',
    },
    success: {
      main: '#4CAF50',
    },
  },
  overrides: {
    MuiButton: {
      containedSecondary: {
        backgroundColor: '#5081FF', // set the background color for containedSecondary buttons
      },
    },
    MuiTooltip: {
      popper: {
        marginBlockStart: -38,
      },
      tooltip: {
        backgroundColor: 'grey',
        width: 'auto',
        height: 'auto',
        position: 'relative',
      },
      arrow: {
        animationDirection: 'bottom',
      },
    },
  },
});

export const useAppStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      display: 'flex',
      flexGrow: 1,
      minHeight: `calc(100vh - ${theme.spacing(8)}px)`,
      overflowY: 'auto',
      marginTop: theme.spacing(8),
    },
    appMenuWraper: {
      display: 'flex',
    },
  })
);
